import React, { useState } from 'react'
import useStyles from './styles'
import { Button as B } from '@material-ui/core'
import classnames from 'clsx'

const Button = ({
  children,
  onAction,
  className,
  disableOnClick = false,
  ...rest
}) => {
  const classes = useStyles()

  // for preventing tap to hold and click from firing together
  // when holding it will call onAction but lifting up the mouse
  // or finger from the button will also call onAction
  const [calledClick, setCalledClick] = useState(false)

  const [animationTimeout, setAnimationTimeout] = useState(null)
  const [showPulse, setShowPulse] = useState(false)
  const [showAnimation, setShowAnimation] = useState(false)

  const startBidAnimation = e => {
    setAnimationTimeout(
      setTimeout(() => {
        onAction()
        setCalledClick(true) // sets calledClick to true so onAction can prevent from firing it as well
        setShowPulse(true)
        if (navigator.vibrate) {
          navigator.vibrate([20, 10, 50])
        }
        setTimeout(() => {
          setShowPulse(false)
        }, 600)
        setShowAnimation(false)
        setAnimationTimeout(null)
      }, 600)
    )
    setShowAnimation(true)
  }

  const stopBidAnimation = () => {
    clearTimeout(animationTimeout)
    setShowAnimation(false)
    setAnimationTimeout(null)
  }

  const onStart = () => {
    startBidAnimation()
  }

  const onEnd = () => {
    stopBidAnimation()
  }

  const handleClick = () => {
    if (!disableOnClick) {
      if (calledClick) {
        setCalledClick(false) // onAction has already been called from a tap to hold so we reset it for the next time
      } else {
        onAction() // onAction was not previously called from a tap to hold action so we call it here
      }
    }
  }

  return (
    <B
      size="large"
      variant="contained"
      color="secondary"
      className={classnames(classes.button, className)}
      onClick={handleClick}
      onMouseDown={onStart}
      onTouchStart={onStart}
      onMouseUp={onEnd}
      onTouchEnd={onEnd}
      onTouchCancel={onEnd}
      onContextMenu={e => e.preventDefault()}
      disableRipple
      {...rest}
    >
      <div
        className={classes.pulseRing}
        style={{
          opacity: showPulse ? 0 : 1,
          boxShadow: showPulse ? '0px 0px 10px #fff inset' : '',
          transform: showPulse ? 'scale(1.3, 2)' : 'scale(1, 1)'
        }}
      />
      <div
        className={classes.bidGlow}
        style={{
          width: showAnimation ? '100%' : '0%',
          transition: showAnimation
            ? 'width 500ms ease-in-out'
            : 'width 200ms ease-in-out'
        }}
      />
      {children}
    </B>
  )
}

export default Button



// WEBPACK FOOTER //
// ./src/components/EngagementButtons/Button/index.jsx